// frontend/src/components/Auth/ResetPassword.jsx
//
// Rendered at /reset-password?token=<hex>
// Allows the user to set a new password after clicking the email link.

import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import apiClient from '../../api/client';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import './Login.css';

const ResetPassword = () => {
  const [searchParams]               = useSearchParams();
  const navigate                     = useNavigate();
  const token                        = searchParams.get('token');

  const [password,     setPassword]  = useState('');
  const [password2,    setPassword2] = useState('');
  const [showPw,       setShowPw]    = useState(false);
  const [status,       setStatus]    = useState('idle'); // idle | saving | success | error
  const [message,      setMessage]   = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Link inválido. Faça um novo pedido de recuperação.');
    }
  }, [token]);

  const handleSubmit = async e => {
    e.preventDefault();
    if (password.length < 6) {
      setMessage('A password deve ter pelo menos 6 caracteres.');
      setStatus('error');
      return;
    }
    if (password !== password2) {
      setMessage('As passwords não coincidem.');
      setStatus('error');
      return;
    }
    setStatus('saving');
    setMessage('');
    try {
      const res = await apiClient.post('/auth/reset-password', { token, newPassword: password });
      setMessage(res.data.message || 'Password alterada com sucesso.');
      setStatus('success');
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setMessage(err.response?.data?.error || 'Erro ao repor password. O link pode ter expirado.');
      setStatus('error');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img src={process.env.PUBLIC_URL + '/logo_impetus.svg'} alt="Logo" />
          </div>
        </div>

        <div className="forgot-panel">
          <h3>Nova Password</h3>

          {status === 'success' ? (
            <div className="forgot-success">
              <span style={{ fontSize: 32 }}>✅</span>
              <p>{message}</p>
              <p style={{ fontSize: 12, color: 'var(--gray-500)' }}>
                A redirecionar para o início de sessão…
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:12 }}>
              {message && status === 'error' && (
                <div className="error-message"><span className="error-icon">⚠️</span>{message}</div>
              )}

              <div className="form-group">
                <label>Nova Password</label>
                <div className="password-input-wrap">
                  <input type={showPw ? 'text' : 'password'} value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="Mínimo 6 caracteres" required autoFocus
                    disabled={status === 'saving' || !token} />
                  <button type="button" className="btn-toggle-password" tabIndex={-1}
                    onClick={() => setShowPw(v => !v)}>
                    {showPw ? <FiEyeOff size={16}/> : <FiEye size={16}/>}
                  </button>
                </div>
              </div>

              <div className="form-group">
                <label>Confirmar Password</label>
                <input type={showPw ? 'text' : 'password'} value={password2}
                  onChange={e => setPassword2(e.target.value)}
                  placeholder="Repita a password" required
                  disabled={status === 'saving' || !token} />
              </div>

              <button type="submit" className="btn-login"
                disabled={status === 'saving' || !token}>
                {status === 'saving' ? 'A guardar…' : 'Definir Nova Password'}
              </button>
            </form>
          )}

          <button type="button" className="btn-back-login" onClick={() => navigate('/login')}>
            ← Voltar ao início de sessão
          </button>
        </div>

        <div className="login-footer"><p>Quantix Works v1.0</p></div>
      </div>
    </div>
  );
};

export default ResetPassword;